import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_plus",
  "use": "svg_plus-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"svg_plus\"><path stroke=\"currentColor\" d=\"M8 4H0M8 4H0M4 0v8M4 0v8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol